import request from '@/utils/request';
export const orderTrajectory = (params: any) =>
  request({
    url: 'Order/orderTrace',
    method: 'get',
    params
  });
export const engineerTrack = (params: any) =>
  request({
    url: 'User/engineerTrack',
    method: 'get',
    params
  });
export const getOrderList = (params: any) =>
  request({
    url: 'OrderService/orderList',
    method: 'get',
    params
  });
export const getGrabOrderList = (params: any) =>
  request({
    url: 'OrderService/grabOrderList',
    method: 'get',
    params
  });
export const orderGrab = (data: any) =>
  request({
    url: 'OrderService/orderGrab',
    method: 'post',
    data
  });

// 维修添加订单初始化 OrderService/init
export const getOrderServiceInit = (params: any) =>
  request({
    url: 'OrderService/init',
    method: 'GET',
    params
  });
  // OrderService/order
  // 创建订单
export const createOrderService = (data:any) =>
  request({
    url: 'OrderService/order',
    method: 'post',
    data
  });

export const getOrderDetail = (params:any) =>
  request({
    url: 'OrderService/order',
    method: 'get',
    params
  });
  // 删除订单
export const delOrderService = (data:any) =>
  request({
    url: 'OrderService/order',
    method: 'DELETE',
    data
  });
  // OrderService/reallyDelete
// 删除订单
export const reallyDelete = (data:any) =>
  request({
    url: 'OrderService/reallyDelete',
    method: 'DELETE',
    data
  });
  
export const getOrderServiceBBSList = (params: any) =>
  request({
    url: 'OrderService/bbsList',
    method: 'get',
    params
  });

export const orderServiceOrderHang = (data: any) =>
  request({
    url: 'OrderService/orderHang',
    method: 'post',
    data
  });

export const orderServiceOrderClose = (data: any) =>
  request({
    url: 'OrderService/orderClose',
    method: 'PUT',
    data
  });

export const getOrderDispose = (params: any) =>
  request({
    url: 'OrderService/orderDispose',
    method: 'get',
    params
  });
export const getOrderServiceProgressList = (params: any) =>
  request({
    url: 'OrderService/progressList',
    method: 'get',
    params
  });
export const assignOrders = (data: any) =>
  request({
    url: 'OrderService/assignOrders',
    method: 'post',
    data
  });
export const orderAssign = (data: any) =>
  request({
    url: 'OrderService/orderAssign',
    method: 'post',
    data
  });

export const transferOrders = (data: any) =>
  request({
    url: 'OrderService/batchTransFerOrder',
    method: 'post',
    data
  });

export const orderTransfer = (data: any) =>
  request({
    url: 'OrderService/orderTransfer',
    method: 'post',
    data
  });

export const orderFinish = (data: any) =>
  request({
    url: 'OrderService/orderFinish',
    method: 'put',
    data
  });
export const orderBatchFinish = (data: any) =>
  request({
    url: 'OrderService/orderBatchFinish',
    method: 'put',
    data
  });
  // 导出任务列表
export const taskExportList = (params: any) =>
  request({
    url: 'OrderService/taskExportList',
    method: 'get',
    params
  });
  // 导入订单OrderService/importOrder
export const importOrder = (data: any) =>
  request({
    url: 'OrderService/importOrder',
    method: 'post',
    data
  });
  // 导出图片
export const exportImage = (params: any) =>
  request({
    url: 'OrderService/exportImage',
    method: 'get',
    params
  });
// 导出工作单
export const exportEorder = (params: any) =>
  request({
    url: 'OrderService/exportEorder',
    method: 'get',
    params
  });
// 导出Excel
export const exportOrderList = (params: any) =>
  request({
    url: 'OrderService/exportOrderList',
    method: 'get',
    params
  });
  // 导出Excel
export const exportOrderComplaint = (params: any) =>
  request({
    url: 'OrderService/exportOrderComplaint',
    method: 'get',
    params
  });
  // 退回
export const sendBack = (params: any) =>
  request({
    url: 'OrderService/sendBack',
    method: 'get',
    params
  });
// 恢复
export const recover = (data: any) =>
  request({
    url: 'OrderService/recover',
    method: 'put',
    data
  });
  // 评价
export const evaluateInit = (params: any) =>
  request({
    url: 'OrderService/evaluate',
    method: 'get',
    params
  });
export const evaluate = (data: any) =>
  request({
    url: 'OrderService/evaluate',
    method: 'post',
    data
  });

export const chargePrice = (data: any) =>
  request({
    url: 'OrderService/chargePrice',
    method: 'put',
    data
  });
// 添加预约时间
export const addAppointmentTime = (data: any) =>
  request({
    url: 'OrderService/appointmentTime',
    method: 'post',
    data
  });
  // 加急
export const expedited = (data: any) =>
  request({
    url: 'OrderService/expedited',
    method: 'PUT',
    data
  });
// 自定义
export const diyContent = (data: any) =>
  request({
    url: 'OrderService/diyContent',
    method: 'PUT',
    data
  });
  export const editDeviceSn = (data: any) =>
  request({
    url: 'OrderService/deviceSn',
    method: 'PUT',
    data
  });
  // 获取客户最近一次报修
export const getCustomerAddressInfo = (params: any) =>
  request({
    url: 'OrderService/customerAddressInfo',
    method: 'get',
    params
  });
  // 回访列表
export const getQuestionnaire = (params: any) =>
  request({
    url: 'OrderService/questionnaire',
    method: 'get',
    params
  });
  // 回访
export const returnVisit = (data: any) =>
  request({
    url: 'OrderService/returnVisit',
    method: 'post',
    data
  });
  // 生成报价单
export const createQuoteOrder = (data: any) =>
  request({
    url: 'OrderService/quoteOrder',
    method: 'post',
    data
  });
export const orderCheck = (data: any) =>
  request({
    url: 'OrderService/orderCheck',
    method: 'put',
    data
  });
export const getOrderServiceBranchOrderList = (params: any) =>
  request({
    url: 'OrderService/branchOrderList',
    method: 'get',
    params
  });
  // 批量关闭
export const batchOrderServiceOrderClose = (data: any) =>
  request({
    url: 'OrderService/batchOrderClose',
    method: 'PUT',
    data
  });
export const batchOrderServiceOrderSettle = (data: any) =>
  request({
    url: 'OrderService/batchOrderSettle',
    method: 'PUT',
    data
  });
export const addDevice = (data: any) =>
  request({
    url: 'OrderService/returnVisit',
    method: 'post',
    data
  });
export const charge = (data: any) =>
  request({
    url: 'OrderService/charge',
    method: 'post',
    data
  });
  // 
  export const getBbsOrderServiceList = (params: any) =>
  request({
    url: 'OrderService/bbsOrderList',
    method: 'get',
    params
  });
